export default {
    login: "/api/v1/authorizations",
    register:'/api/v1/users',
    registerCaptcha:'/api/v1/captchas',
    user_info: '/api/v1/user',
    user_update: '/api/v1/updateUser',
    user_changepass: '/api/v1/changePass',
    logout:'/api/v1/authorizations/current',
    income:'/api/v1/income/index',
    income_data:'/api/v1/income/data',
    income_apply:'/api/v1/income/apply',
    getUnders:'/api/v1/getUnders',
    getCommissionInfo:'/api/v1/withdraw/commission',
    withdrawApply:'/api/v1/withdraw/apply',
    withdrawLists:'/api/v1/withdraw/lists',
    // 账单明细
    billingDetails:'/api/v1/bill/details',

    // 联系我们信息提交
    contact_us:'/api/v1/message',
    // 产品页面导航栏数据
    categories:'/api/v1/categories',
    //获取产品数据
    pd_list:'/api/v1/products',
    pd_detail:'/api/v1/productDetail',
    //获取关于我们数据
    about:'/api/v1/aboutUs'
}
